import React, { Component } from "react";
import { Container, Spinner } from "reactstrap";
import ChatBot from "../helpers/chatbotNewWidget";
import fetchUserDetailsFromParmsOrCookie from "../helpers/token-util";
import TypeForm from "./typeform";
import { KEY_CHAIN } from "../constants";
import getOS from "../helpers/getBrowserType";
import ChatbotNotAccessible from "../helpers/isChatbotAccessible";
import TrackSnowPlowEvents from "../helpers/trackSnowPlowEvents";

class UpdatedWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetailsFetched: false,
      userDetails: null,
      longToken: "",
      shortToken: "",
      isLoading: true,
    };
  }

  componentDidMount() {
    fetchUserDetailsFromParmsOrCookie()
      .then((resp) => {
        if (resp) {
          this.setState({
            userDetailsFetched: true,
            userDetails: resp.userInfo,
            longToken: resp.longToken,
            shortToken: resp.shortToken,
          });
        } else {
          this.setState({ userDetailsFetched: true, userDetails: null });
        }
      })
      .catch(() => {
        this.setState({ userDetailsFetched: true, userDetails: null });
      })
      .finally(() => {
        this.setState({ isLoading: false });
        TrackSnowPlowEvents(this.state.userDetails);
      });

  }

  redirectToTypeform = () => {
    this.setState({ isLoading: true });

    let typeformlink = KEY_CHAIN.SURGERY_TYPEFORM_LINK;
    let deviceOs = getOS();
    typeformlink = typeformlink + "platform=" + deviceOs;

    if (this.state.userDetails && this.state.userDetails.phone) {
      typeformlink = typeformlink + "&phone=" + this.state.userDetails.phone;
    }

    window.location.assign(typeformlink);
  };

  render() {
    const {
      userDetailsFetched,
      userDetails,
      longToken,
      shortToken,
      isLoading,
    } = this.state;

    if (isLoading || !userDetailsFetched) {
      return (
        <main role="main" aria-label="Loading Support Chat">
          <Container>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
              role="status"
              aria-live="polite"
              aria-label="Loading support chat widget"
            >
              <Spinner color="primary" />
            </div>
          </Container>
        </main>
      );
    }

    return (
      <main role="main" aria-label="Customer Support Chat">
        <Container>
          <div>..</div> {/* Render dialog */}
          <section role="region" aria-label={ChatbotNotAccessible(userDetails) ? "Alternative Support Form" : "Chat Widget"}>
            {userDetailsFetched && !ChatbotNotAccessible(userDetails) && (
              <ChatBot
                userDetails={userDetails}
                longToken={longToken}
                shortToken={shortToken}
              />
            )}
            {userDetailsFetched && ChatbotNotAccessible(userDetails) && (
              <TypeForm userDetails={userDetails} />
            )}
          </section>
        </Container>
      </main>
    );
  }
}

export default UpdatedWidget;
